import React, {useState} from 'react'
import {Button, Form} from 'semantic-ui-react'
import Dialog from '../../dialog'
import * as Yup from 'yup'
import {GlossarySave} from "../../../fetch/glossary"
import {getApiResponseErrorMessage} from '../../error'
import {fieldNames, options} from "../options"

const DataDialog = ({ title, open, loading, type, onSubmit, onClose, item }) => {

    const initialState = {
        name: '',
        definition: '',
        status: '',
        type: type,
        //id: null,
    }
    const [state, setState] = useState(initialState)

    if( item && item.id && (state.id === null || state.id !== item.id)) {
        setState( state => {
            return {
                name: item.name,
                definition: item.definition,
                status: item.status,
                id: item.id,
                type: type
            }
        })
    }


    const [errors, setError] = useState({})

    const formSchema = Yup.object().shape({
        name: Yup.string().required('Name is required'),
        status: Yup.string().required(),
        definition: Yup.string().required('Definition is required'),
    });

    const handleInputChange = (e, {name, value}) => {

        if (errors[name] === true) {
            setError( errors => {
                return {
                    ...errors,
                    [name]: false
                }
            })
        }

        setState( state => {
            return {
                ...state,
                [name]: value
            }
        })

    }

    const handleOnSubmit = () => {

        setError({})

        formSchema.validate(state, {abortEarly: false}).then( data => {

            setState( state => {
                return {
                    ...state,
                    loading: true
                }
            })

            //API.post()

            // Callback
            if (typeof onSubmit === 'function') {
                //onSubmit(data);

                const reply = GlossarySave(`/${type}/save`, data)

                reply.then(res => {
                    //console.log(res)
                    if (res.success === true) {
                        onSubmit()
                        setState(state => initialState);
                    }
                }).catch(error => {
                    const errorFields = {}

                    for (const [key, value] of Object.entries(error.response.data.messages)) {
                        errorFields[key] = getApiResponseErrorMessage({key: value, prefix: fieldNames[key]})
                    }

                    setError( err => {
                        return {
                            ...err,
                            ...errorFields
                        }
                    })

                    setState( state => {
                        return {
                            ...state,
                            dialogLoading: false
                        }
                    })
                })

                //setState(state => initialState);
            }

        }).catch( errors => {

            const errorFields = {}

            errors.inner.forEach( error => errorFields[error.path] = error.message.replace(error.path, fieldNames[error.path]))//true)

            setError( err => {
                return {
                    ...err,
                    ...errorFields
                }
            })

        })

    }

    const _onClose = () => {
        setState(state => initialState);
        setError({})
        onClose()
    }


    return (
        <Dialog open={open} onClose={_onClose} closeOnEscape={false} closeOnDimmerClick={false}>

            <Form onSubmit={handleOnSubmit} loading={loading}>

                <Dialog.Header>
                    {title}
                </Dialog.Header>

                <Dialog.Content>

                    <Form.Group widths="equal">

                        <Form.Field>

                            <Form.Input
                                name="name"
                                error={errors.name}
                                label="Term name"
                                placeholder="Enter term name"
                                onChange={handleInputChange}
                                defaultValue={item.name ? item.name : "" }
                            />

                            <br />

                            <Form.Select
                                name="status"
                                error={errors.status}
                                label="Term status" options={options}
                                placeholder="Select status"
                                defaultValue={ (item && item.status) ? item.status : '' }
                                onChange={handleInputChange}
                                icon={"chevron down"}
                            />

                        </Form.Field>

                        <Form.Field>
                            <Form.TextArea
                                style = {{minHeight: "106px"}}
                                name="definition"
                                error={errors.definition}
                                label="Term definition"
                                defaultValue={ (item && item.definition) ? item.definition : "" }
                                onChange={handleInputChange}
                            />
                        </Form.Field>

                    </Form.Group>

                </Dialog.Content>

                <Dialog.Actions>
                    <Button type="submit" primary>
                        Submit
                    </Button>
                    <Button onClick={_onClose}>
                        Close
                    </Button>
                </Dialog.Actions>

            </Form>
        </Dialog>
    )

}


export default DataDialog